// extracted by mini-css-extract-plugin
export default {"wrapper":"AD-z","addressLine":"BD-z","fullName":"CD-z"};